/* jshint undef: true, unused: true */
/* globals require */

var notJquery = require('../not-jquery'),
    FoBuComponentFactory = require('./fobu-component-factory');

// REFACTOR: `inputwithbutton` should really be replaced with a  combo of an input and a button. That’s what it is there for after all…

module.exports = function component (componentSettings, foBu) {

  var nJ               = notJquery,
      componentFactory = new FoBuComponentFactory(componentSettings, foBu),
      componentObject  = componentFactory.getComponentObject(),
      element          = componentObject.element,
      wrapper          = componentObject.wrapper,
      inputElement     = document.createElement('input');


  nJ.removeClass(element, 'form-control');
  nJ.removeClass(element, componentSettings.attributes.class);
  nJ.addClass(inputElement, ['form-control', 'form-input' ]);
  element.appendChild(inputElement);


  componentSettings.inputElement = inputElement;
  componentSettings.domElement = element;
  inputElement.foBuSettings = componentSettings;
  element.foBuSettings = componentSettings;

  foBu.addAttributes(inputElement, componentSettings.attributes);
  foBu.addAttributes(inputElement, {'autocomplete' : 'off'});
  foBu.addAttributes(inputElement, {'name' : foBu.getInputName(componentSettings.attributes.name)});


  if(componentSettings.inputWithButtonProps)
  {
    nJ.addClass(element, 'inputwithbutton__wrapper');
    if (componentSettings.comboWrapperClass) {
      nJ.addClass(element, componentSettings.comboWrapperClass);
    }
    var searchInputAddon = foBu.addSearchIcon(element, componentSettings || {});
    element.appendChild(searchInputAddon);
    componentSettings.inputWithButtonProps.initScript(inputElement,searchInputAddon,foBu);

  }
  foBu.manageEventListener(inputElement, 'change', function (event) {
    foBu.validation.validateElement(foBu.settings.uid, event.target.name);
  });


  wrapper.appendChild(element);


  return {
    wrapper           : wrapper,
    finaliseComponent : componentFactory.finaliseComponent
  };
};
